import React, { Component } from 'react'
import '../stylesheets/main.scss'
import '../stylesheets/components/timeline.scss'
import ReactHtmlParser from 'react-html-parser'
import MapContainer from './MapContainer'

class Timeline extends Component{

	constructor(props){
		super(props)

		this.state = {
			points: [],
		}

		this.updatePoint = this.updatePoint.bind(this)
	}

	componentDidMount(){
		fetch('https://www.serasaconsumidor.com.br/serasaitinerante/manager/api/v1/points')
	      .then(response => response.json())
	      .then(data => { 
	      	this.setState({ points: data });
	      });

	    fetch('https://www.serasaconsumidor.com.br/serasaitinerante/manager/api/v1/point/active')
	      .then(response => response.json())
	      .then(data => this.setState({ 	
	      								city: data[0].name, 
				    					resume: data[0].resume, 
				    					location: data[0].location, 
				    					region: data[0].region, 
				    					period: data[0].period, 
				    					destination: data[0].destination, 
				    					id: data[0].id 
									}));

	    document.getElementById('left-button').onclick = function () {
		   scrollLeft(document.getElementById('timeline'), -300, 1000);   
		}

		document.getElementById('right-button').onclick = function () {
		   scrollLeft(document.getElementById('timeline'), 300, 1000);   
		}
		    
		function scrollLeft(element, change, duration) {
		    var start = element.scrollLeft,
		        currentTime = 0,
		        increment = 20;
		        
		        console.log(start)
		        
		    var animateScroll = function(){        
		        currentTime += increment;
		        var val = Math.easeInOutQuad(currentTime, start, change, duration);
		        element.scrollLeft = val;
		        if(currentTime < duration) {
		            setTimeout(animateScroll, increment);
		        }
		    };
		    animateScroll();
		}

		//t = current time
		//b = start value
		//c = change in value
		//d = duration
		Math.easeInOutQuad = function (t, b, c, d) {
		  t /= d/2;
			if (t < 1) return c/2*t*t + b;
			t--;
			return -c/2 * (t*(t-2) - 1) + b;
		};

		scrollLeft(document.getElementById('timeline'), 400, 1000);   
	}

	updatePoint(obj, e) {
		e.preventDefault();
	    return this.setState({ city: obj.name, 
	    					   resume: obj.resume, 
	    					   location: obj.location, 
	    					   region: obj.region, 
	    					   period: obj.period, 
	    					   destination: obj.destination, 
	    					   id: obj.id 
	    					});
	}

	render(){

		const itens = this.state.points.map((item) => {
					      return (
					      	<a href="javascript;" onClick={(e) => this.updatePoint(item, e)} className="o-timeline--day" key={item.id} >
					      		<li className={ item.is_active ? 'o-timeline--marker o-timeline--marker-active' : 'o-timeline--marker' } >
					      			<span className="o-timeline--day">{ item.day }</span>
					      			<span className="o-timeline--separator">/</span>
					      			<span className="o-timeline--month">{ item.month }</span>
				            	</li>
				            </a>
					      )
					    })

		return (
			<section className="o-timeline" id="onde-estamos">
	      		<div className="o-container">
	      			<h2 className="c-title c-title--size-big c-title--family-bold c-title--color-white c-title--align-left c-title--border c-title--border-bottom">
						Onde estamos <br /> 
						e para onde vamos
					</h2>
				</div>
					<div className="o-timeline--line-group" >
						<div className="o-container">
			      			<ul className="o-timeline--line" id="timeline">
			      				{ itens }
			      			</ul>
			      			<div className="paddles" >
								<div className="left-paddle paddle c-title c-title--size-small-0 c-title--weight-bold o-uppercase" id="left-button" > Ver menos </div>
								<div className="right-paddle paddle c-title c-title--size-small-0 c-title--weight-bold o-uppercase" id="right-button" > Ver mais </div>
							</div>
			      		</div>

		      			<div className="o-timeline--border"></div>

					</div>
				<div className="o-container">
	      			<div className="o-timeline--map">
	      				<div className="o-row" >
	      					<div className="o-col o-col--width" >

								<div key={this.state.id} >
									<h3 className="c-title c-title--size-small c-title--weight-bold c-title--color-white c-title--align-left o-uppercase">Região {this.state.region}</h3>
									<h4 className="c-title c-title--size-big c-title--weight-regular c-title--color-white c-title--align-left o-uppercase">
				      					{ this.state.city }
				      				</h4>

				      				<p className="c-title c-title--size-small c-title--lineheight-3 c-title--weight-regular c-title--color-white c-title--align-left">
				      					{ ReactHtmlParser( this.state.resume ) }
				      				</p>

				      				<br /><br />

				      				<p className="c-title c-title--size-medium c-title--pinpink c-title--weight-bold c-title--color-pink c-title--align-left">
				      					Onde nos encontrar:
				      				</p>

				      				<p className="c-title c-title--size-meium c-title--weight-regular c-title--color-white c-title--align-left">
				      					{ this.state.location }
				      				</p>

				      				<br />

				      				<p className="c-title c-title--size-medium c-title--calendarpink c-title--weight-bold c-title--color-pink c-title--align-left">
				      					Até quando nos visitar:
				      				</p>

				      				<p className="c-title c-title--size-meium c-title--weight-regular c-title--color-white c-title--align-left">
				      					{ this.state.period }
				      				</p>

				      				<br />

				      				<p className="c-title c-title--size-medium c-title--nextpink c-title--weight-bold c-title--color-pink c-title--align-left">
				      					Qual o nosso próximo destino?
				      				</p>

				      				<p className="c-title c-title--size-meium c-title--weight-regular c-title--color-white c-title--align-left">
				      					{ this.state.destination }
				      				</p>
								</div>

			      			</div>
			      			<div className="o-col o-col--width o-col--position-relative" >
			      				<MapContainer />
			      			</div>
			      		</div>
	      			</div>

	      		</div>
	    	</section>
		)
	}

}

export default Timeline



// WEBPACK FOOTER //
// ./src/components/Timeline.js